import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .rating': {
      '&-content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(3, 0, 0),
        textAlign: 'center',
      },
      '&-chart': {
        '&-container': {
          minHeight: theme.spacing(8),
          margin: theme.spacing(2, 0),
        },
      },
      '&-comment': {
        width: '100%',
      },
    },
  },
  paper: {
    width: '100%',
  },
}));

export default styles;
